import { Routes, Route, Navigate, useLocation, BrowserRouter } from "react-router-dom";
import Home from './../app/home';
import Shop from './../app/shop';
import Dashboard from './../app/dashboard';
import ContactUs from './../app/contact_us';
import AboutUs from './../app/about_us';
import CreatePassword from './../app/create_password';
import LoginOtp from './../app/login_otp';
import NotFound from '../app/notfound';
import PasswordVerify from './../app/password_verify';
import ShopPage from './../app/shop_page';
import SignIn from './../app/signin';
import Login from './../app/login';
import Thankyou from './../app/thankyou';
import UpdatePassword from './../app/updatePassword';
import ProtectedRoute from './ProtectedRoute'
import VerificationThankyou from './../app/verification_thanks';
import CheckInbox from './../app/check_inbox';
import Checkout from './../app/checkout';
import Ingredients from './../app/Ingredients';
import IngredientProducts from './../app/IngredientProducts';

import PrivacyPolicy from './../app/privacy_policy';

export default function RouterComponent() {
  
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/home" element={<ProtectedRoute Element={Home}/>} />
        <Route path="/ingredents" element={<ProtectedRoute Element={Ingredients}/>} />
        <Route path="/shop" element={<ProtectedRoute Element={Shop}/>} />
        <Route path="/shop/:id" element={<ProtectedRoute Element={Shop}/>} />
        <Route path="/dashboard" element={<ProtectedRoute Element={Dashboard}/>} />
        <Route path="/contactus" element={<ProtectedRoute Element={ContactUs}/>} />
        <Route path="/verificationthankyou" element={<ProtectedRoute Element={VerificationThankyou}/>} />
        <Route path="/updatepassword" element={<ProtectedRoute Element={UpdatePassword}/>} />
        <Route path="/thankyou" element={<ProtectedRoute Element={Thankyou}/>} />
        <Route path="/signin" element={<ProtectedRoute  Element={SignIn}/>} />
        <Route path="/shoppage" element={<ProtectedRoute Element={ShopPage}/>} />
        <Route path="/shoppage/:searchKey" element={<ProtectedRoute Element={ShopPage}/>} />
        <Route path="/passwordverify" element={<ProtectedRoute authPath={true} Element={PasswordVerify}/>} />
        <Route path="/login" element={<ProtectedRoute authPath={true} Element={Login}/>} />
        <Route path="/" element={<ProtectedRoute authPath={true} Element={Login}/>} />
        <Route path="/loginotp" element={<ProtectedRoute authPath={true} Element={LoginOtp}/>} />
        <Route path="/loginotp/:mobile/:type" element={<ProtectedRoute authPath={true} Element={LoginOtp}/>} />
        <Route path="/loginotp/:mobile" element={<ProtectedRoute authPath={true} Element={LoginOtp}/>} />
        <Route path="/createpassword" element={<ProtectedRoute Element={CreatePassword}/>} />
        <Route path="/checkinbox" element={<ProtectedRoute Element={CheckInbox}/>} />
        <Route path="/checkout" element={<ProtectedRoute Element={Checkout}/>} /> */}

        <Route path="/home" element={<Home />} />
        <Route path="/ingredents" element={<Ingredients />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:id" element={<Shop />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/verificationthankyou" element={<VerificationThankyou />} />
        <Route path="/updatepassword" element={<UpdatePassword />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/shoppage" element={<ShopPage />} />
        <Route path="/shoppage/:searchKey" element={<ShopPage />} />
        <Route path="/passwordverify" element={<PasswordVerify />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/loginotp" element={<LoginOtp />} />
        <Route path="/loginotp/:mobile/:type" element={<LoginOtp />} />
        <Route path="/loginotp/:mobile" element={<LoginOtp />} />
        <Route path="/createpassword" element={<CreatePassword />} />
        <Route path="/checkinbox" element={<CheckInbox />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/Ingredient/:id" element={<IngredientProducts />} />
        <Route path="/404" element={<NotFound />} />
        
      </Routes>
    </BrowserRouter>
  )
}
